import React, {useState, useEffect} from 'react'
import { CNav,CNavItem,CCard,CRow, CCol,CInput,
         CImg,CCardHeader,CCardTitle,CForm,
         CCardBody,CButton,CNavLink, CFormGroup,
} from 'compat/coreui';
/*import BusinessDashboard from './BusinessDashboard';
import BusinessMenu from './BusinessMenu';
import BusinessDeals from './BusinessDeals';
import ReviewSection from './ReviewSection';*/
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {getData} from '../../../helpers/api';
import moment from 'moment';
import Rating from 'react-rating';


export default function PublicProfile(props) {
    const token = localStorage.getItem('token');
    const [compCard, setCompCard] = useState('dashboard');
    const [bizId, setBizId] = useState('');
    const [sellerData, setSellerData] = useState({});
    const [follow, setFollow] = useState(true);
    const [review, setReview] = useState('');

    const location = useLocation();
    const user = useSelector(state => state.user);

    useEffect(() => {
        const path = location.pathname.split('/')[2];
        setBizId(path);
        getBizDetails(path);
        getFollowers();
        reviewHandler();
    }, [])

    const reviewHandler = () => {

        axios({url: `${process.env.REACT_APP_APP_API_URL}/api/review`,
               headers: {
                    Authorization: `Bearer ${token}`
               },
               method: `GET`
            }).then(response => {
                console.log('review api response', response);
                if(response.data.status){
                    setReview(response.data.review);
                }
            }).catch(console.log)
    }


    const getFollowers = () =>{
        getData(`${process.env.REACT_APP_APP_API_URL}/api/follow`).then(res => {
            if(res.data.status){
                const path = location.pathname.split('/')[2];
                res.data.following.forEach(d => {
                    let fid = d.following
                    if(fid._id === path) {
                        setFollow(false);
                    }
                });
            }
        }).catch(console.log)
    }



    const getBizDetails = (path) => {
        axios({
          // url: `${process.env.REACT_APP_APP_API_URL}/api/seller/${path}`,
          url: `${process.env.REACT_APP_APP_API_URL}/api/seller/${user._id}`,
          method: 'GET',
          headers: {
            'Authorization': 'Bearer '+token
          },
        }).then(response => {
            // console.log('seller', response)
            if(response.data.status){
                setSellerData(response.data.sellers[0]);
            }
      }).catch(console.log)
    }


    const followerHandler = () => {
        const data = {
            "seller": bizId
        }
        axios({
            url: `${process.env.REACT_APP_APP_API_URL}/api/follow`,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer '+token
            },
            data,
        }).then(response => {
            if(response.data.status) {
                setFollow(false)
                toast.success('Followed successfully')
            }
        }).catch(console.log)
    }

    const unfollow = (id) =>{
        console.log(id)
        axios({
                url: `${process.env.REACT_APP_APP_API_URL}/api/unfollow`,
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer '+token
                },
                data: {"seller": id}
            }).then(response => {
                if(response.data.status) {
                    setFollow(true)
                    toast.success('Unfollowed successfully')
                }
            }).catch(console.log)
    }
    const getItemCount = id => {
        return sellerData.products.filter(p => p.category === id).length
    }

    return (
        <React.Fragment>
        <div className="business-info-section">
            <CCard className="business-info-card">
                <CCardHeader className="info-header">
                {user.image ?
                    <CImg src={'https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/'+user.image} width="150" height="150" className="rounded-circle b-info-pic"/>
                    : <CImg src="/images/product-1.jpg" width="150" height="150" className="rounded-circle b-info-pic"/> }
                    <CCardTitle className="info-title">
                        <div>
                            <p>{user.businessName}</p>
                            <span>{user.businessType}</span>
                        </div>
                        <div>
                            <p>{user.ownerPhone}</p>
                            {follow  ?
                                (<><span>546</span><CButton color="warning" className="text-white ml-1" onClick={followerHandler}>FOLLOW</CButton></>) :
                                (<><span>546</span><CButton color="warning" className="text-white ml-1" onClick={(e) => unfollow(sellerData._id)}>UNFOLLOW</CButton></>)
                             }
                        </div>
                    </CCardTitle>
                </CCardHeader>
                <CCardBody className="mb-0 pb-0">
                    <CNav variant="tabs" color="success">
                      <CNavItem>
                        <CNavLink active={compCard === 'dashboard'}>Dashboard</CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink to="/dashboard/menu-products" active={compCard === 'menu'}>Menu</CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink to="/dashboard/deals" active={compCard === 'deals'}>Deals</CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink to="/dashboard/reviews" active={compCard === 'reviews'}>Reviews</CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink to="/dashboard/gallery" active={compCard === 'photos'}>Photos</CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink>:</CNavLink>
                      </CNavItem>
                    </CNav>
                </CCardBody>
            </CCard>
            <CCard className="business-dashboard">
                <CCardBody>
                <CRow style={{fontSize: '14px'}} className="biz_left_boxes">
                    <CCol sm={12} lg={6} className="geoloc-section profile_content biz_details">
                        <span className="map_wrap"><CImg src="/images/static-map.png" width="62%"/></span>
                        <div className="profile_left_subnav">
                            <ul>
                                <li><span style={{marginRight: "6px"}}><i className="fa fa-map-marker"></i></span>{user.city} {user.state} {user.pincode}</li>
                                <li><span style={{marginRight: "6px"}}><i className="fa fa-phone"></i></span>{user.ownerPhone}</li>
                                <li><span style={{marginRight: "6px"}}><i className="fa fa-phone"></i></span>{user.website}</li>
                                <li><span style={{marginRight: "6px"}}><i className="fa fa-phone"></i></span>{user.businessType}</li>
                                <li>
                                    <span style={{color: 'green', marginRight: "6px"}}>
                                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                                   </span>
                                    Open (Show More) Sun 9am - 10pm
                                </li>
                            </ul>
                        </div>
                    </CCol>
                    <CCol className="biz_details" sm={12} lg={6}>
                        <h3 style={{color: 'green'}}>Amenities</h3>
                        <div className="business-dash-amenities">
                            <ul>
                                <li><i className="fa fa-truck"></i>Delivery Only</li>
                                <li><i className="fa fa-phone"></i>Recreational</li>
                                <li><i className="fa fa-star"></i>Veteran Discounts</li>
                            </ul>
                            <h3 style={{color: 'green'}}>First Time Patients</h3>
                            <span className="ml-2">{user.note}</span>
                            <h3 style={{color: 'green'}}>About</h3>
                            <span className="ml-2">{user.about}</span>
                        </div>
                    </CCol>
                </CRow>
                </CCardBody>
            </CCard>
            <CCard className="profile_content business-dashboard">
                <div className="biz_module biz_menu c_12 doaj" data-position="rig">
                  <h3 className="heading" style={{color: '#FF5F1F'}}>Menu &amp; Products</h3>
                  <fieldset className="menus">
                    <ul className="aj">
                      {(sellerData && sellerData.menus ) && Object.values(sellerData.menus).map((item, i) => (
                        <li className="menu_headline" key={i}>
                          <a href="#">
                            <img src="/images/indica.jpg" className="category_img" alt="Indica" />
                            <span className="title">{item.title}</span>
                            <span className="bottom_row">
                              <span className="count">{getItemCount(item._id)} Items</span>
                              <span property="priceRange" className="price_range">$40 - $60 per </span>
                            </span>
                          </a>
                        </li>
                      ))}
                   </ul>
                    <p className="updated">Menu last updated January 2, 2021</p>
                  </fieldset>
                  <span className="pre_order_stats">
                    <span className="oo_cta">
                      <Link to="/dashboard/menu-products">
                        Pre-Order Now
                      </Link>
                    </span>
                  </span>
                </div>
            </CCard>
            <CCard className="business-dashboard">
                <CCardBody>
                    <CRow className="p-4">
                        <CCol xl={4}>
                            <p className="review-headding ml-0"><h2>Reviews & Tips</h2></p>
                            <div>
                                <div className="hexagon"><span>{review.length} Reviews</span></div>
                            </div>
                        </CCol>

                    </CRow>

                    <CRow>
                        <CCol xl={12}>
                            <table className="review-table">
                                <tbody>
                                    {review  && review.map((reviewItem, i) => {
                                        const postTime = moment(reviewItem.createdAt, 'YYYY-MM-DD').format('DD-MM-YY');
                                        return(<tr key={i}>
                                                <td><CImg  width="77%" src="/images/smoke1.png" className="rounded-circle" /></td>
                                                <td>
                                                    <div>
                                                        <p>{reviewItem.msg}</p>
                                                        <span className="feature-text">Featured</span>
                                                        <span>{Array.apply(null, {length: reviewItem.rating}).map((i, index) => <CImg  width="30" src="/images/11.png" key={index}/>)}</span>
                                                        <span>Posted on {postTime}</span>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        )}) }
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </div>
        </React.Fragment>
    )
}